import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatPaginator } from '@angular/material';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-receive-amount',
  templateUrl: './receive-amount.component.html',
  styleUrls: ['./receive-amount.component.scss']
})
export class ReceiveAmountComponent implements OnInit {
  @Input() dataSource
  @Input() getExistingDetails
  @Input() caseData

  @Output() existingPositiveDetails = new EventEmitter<any>();
  @Output() deletedPositiveTransaction = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  receiveTrasction = []
  removedTransactions = [];

  positiveDetails = []
  totalAmount = 0;
  receiveTrasctionHeaders = ['item_id', 'date', 'name', 'category', 'account_id', 'amount']
  receiveTrasctionFooter = []
  accountIds = [];
  accountNames = {};
  isAllSelect: boolean = false;
  selectedRow = []
  constructor() { }

  ngOnInit() {
  }
  ngOnChanges() {
    if (this.dataSource) {
      this.receiveData()

    }
    if (this.caseData) {
      this.getCurrentBalance()

    }
    if (this.getExistingDetails) {
      this.submitForm()
    }
  }

  getCurrentBalance() {
    let banks = this.caseData.plaid_accounts;
    let total = 0;
    let accountIds = [];

    if (banks === null) {
      // this.hideMe.emit('overview');
      return;
    }

    for (let i = 0; i < banks.length; i++) {
      for (let ii = 0; ii < banks[i].accounts.length; ii++) {

        total += banks[i].accounts[ii].balances.current;
        this.accountIds.push(banks[i].accounts[ii].account_id);
        this.accountNames[banks[i].accounts[ii].account_id] = banks[i].accounts[ii].name;

      }
    }
  }
  receiveData() {
    this.receiveTrasctionFooter = ['Total', '', '', '', this.totalAmount]
  }

  removeTransaction(transaction) {
    this.dataSource = this.dataSource.filter(item => item.transaction_id !== transaction.transaction_id)
    this.removedTransactions.push(transaction)
    this.positiveDetails = this.dataSource
  }

  submitForm() {
    this.existingPositiveDetails.emit(this.positiveDetails)
    this.deletedPositiveTransaction.emit(this.removedTransactions)
  }

  checkedToggle(transaction, event) {
    if (this.selectedRow.find(item => item.transaction_id === transaction.transaction_id)) {
      this.selectedRow = this.selectedRow.filter(element => element.transaction_id !== transaction.transaction_id)
    } else {
      this.selectedRow.push(transaction)
    }
  }

  removeSelectedRow() {
    this.selectedRow.forEach(item => {
      this.dataSource = this.dataSource.filter(element => element.transaction_id !== item.transaction_id)
      this.positiveDetails = this.dataSource
    })
    this.isAllSelect = false;
    this.selectedRow = []
  }

  selectAll() {
    this.isAllSelect = !this.isAllSelect;
    if (this.isAllSelect) {
      this.selectedRow = []
      this.selectedRow = this.dataSource
    } else {
      this.selectedRow = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/seven-one/component/receive-amount/receive-amount.component.ts